import { RichTextPageSection } from "../../models/page-builder/rich-text-section.model";

export const MOCK_PAGE_RICH_TEXT_SECTION: RichTextPageSection = {
  type: "rich-text-section",
  content: {
    htmlText: "<p>Start your free trial\n" +
      " Join over 4,000+ users already growing with OnlineCourseHost.com</p>",
  },
  design: {
    layout: {
      blockStyle: "plain",
        blockAlignment: "center"
    },
    appearance: {
      backgroundColor: "rgba(230, 226, 226, 1)",
      cardBackgroundColor: "grey",
      textColor: "black",
      backgroundImage: {
        type: "image",
        originalFileName: "background-original",
        uploadFileName: "background.Mp4",
        url: '',//"https://play-lh.googleusercontent.com/7Ak4Ye7wNUtheIvSKnVgGL_OIZWjGPZNV6TP_3XLxHC-sDHLSE45aDg41dFNmL5COA=w240-h480-rw",
        imageSettings: {
          overlayWithBackground: true,
          opacity: 0.1,
          blending: "normal",
          blur: 2,
          grayScale: 10,
          contrast: 100,
        },
      },
    }
  }
}
